import React from 'react';
import IconInfoBox from '../Common/IconInfoBox';
import { useTranslation } from 'react-i18next';

const ProductMainDescription = ({ productDescription }) => {
  const { t } = useTranslation();

  return (
    <div className={'product-main-desc-wrapper'}>
      <h3 className={'product-main-desc-title'}>{t('product_information')}</h3>
      {/* map 적용 부분 */}
      {productDescription?.map((item, index) => {
        // 해당 객체의 모든 값이 null인 경우 화면에 미출력
        const isAllFalsy = !item.image && !item.text;
        if (isAllFalsy) {
          return null;
        }
        return <IconInfoBox key={index} item={item} />;
      })}
    </div>
  );
};

export default ProductMainDescription;
